<template>
  <div class="Average" :class="{ 'Average_visible': isAlreadyVisible }">
    <router-link :to="{ name: 'qualiscore' }" v-if="value <= 0"></router-link>
    <div class="Average_infos">
      <transition name="fade" mode="out-in">
        <p class="Average_title" v-html="label" :key="label"></p>
      </transition>
      
      <div class="Average_value">
        <animated-number
          v-if="value && value > 0"
          :value="value"
          :easing="'easeOutQuad'"
          :duration="value * 150"
          :formatValue="format"
        />
        <b v-else>?</b>
        <span>/ 10</span>
      </div>
    </div>
    <div class="Average_percent">
      <div class="Average_percent_value" :style="{ width: width, backgroundColor: color ? color : null }"></div>
      <div class="Average_percent_user" :style="{ left: user * 10 + '%' }" v-if="user" ref="user"><p>Vous ({{ user }})</p></div>
    </div>
    <p class="Average_desc" v-if="higher >= 0"><b>{{ higher }}%</b> {{ desc }}
    </p>
  </div>
</template>

<script>
  import scrollUpdate from '@/mixins/scrollUpdate'
  import { TweenMax, ScrollToPlugin, Expo } from 'gsap/all'

  import AnimatedNumber from "animated-number-vue";

  export default {
    name: "Average",
    props: [ 'value', 'label', 'color', 'desc', 'user', 'higher' ],
    components: {
      AnimatedNumber
    },
    mixins: [ scrollUpdate ],
    data() {
      return {
        width: null,
        isAlreadyVisible: false
      }
    },
    watch: {
      value()
      {
        this.checkWidth()
      }
    },
    methods: {
      format(value)
      {
        return Number(value).toFixed(1).replace(".", ",");
      },
      onVisible()
      {
        this.checkWidth()
        // if(this.$refs.user && !this.isAlreadyVisible)
        //   TweenMax.fromTo(this.$refs.user, 1, { opacity: 0, y: 8 }, { opacity: 1, y: 0, ease: Expo.easeOut, delay: 1.6 })

        this.isAlreadyVisible = true
      },
      checkWidth()
      {
        this.width = this.value * 10 + '%'
      }
    }
  }
</script>

<style lang="stylus">
.Average

  position relative 
  background: #FFFFFF;
  box-shadow: 0 2px 24px 0 rgba(0,0,0,0.10);
  border-radius: 5px;
  padding 20px 34px
  box-sizing border-box
  width 100%
  max-width 590px
  color $blue
  margin-top 10px

  &_visible

    .Average_percent_user

      opacity 1

  @media $small

    padding 20px 20px

  &:hover

    i

      transform translateX(8px)

  a

    cursor pointer
    position absolute
    z-index 2
    height 100%
    width 100%
    top 0px
    left 0px

  &_desc

    font-family: $f-content
    font-size: 16px;
    margin-top 35px
    color: $s1
    text-align left
    font-weight 400
    line-height: 24px;

    b

      color white
      background-color $blue
      padding 1px 4px
      margin-right 2px
      border-radius 3px

  &_infos

    display flex
    flex-direction row
    align-items center
    justify-content space-between
    width 100%

  &_title

    font-family: $f-title
    font-weight 500
    font-size: 18px;
    color: $blue
    text-align left
    letter-spacing: -0.3px;
    line-height: 22px;

    i

      color $red
      display inline-block
      margin-left 8px
      position relative
      top 1px
      transition all 0.6s $ease

  &_value

    font-family: $f-title
    font-weight 500
    font-size: 18px;
    color: $blue
    letter-spacing: -0.3px;
    text-align: right;
    line-height: 22px;
    min-width 70px

    b

      color inherit
      font-weight 500

    span:last-child

      font-size: 14px;
      color: $s1
      margin-left 5px
      line-height: 17px;

  &_percent

    width 100%
    background: $n3;
    border-radius: 7.5px;
    height 15px
    margin-top 10px
    position relative

    &_value

      width 0%
      transition 1.5s 0.5s $ease
      height 100%
      position absolute
      left 0px
      top 0px
      background-color $cyan
      border-radius 7.5px

    &_user

      position absolute
      top calc(100% - 3px)
      opacity 0
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 7px solid $blue;
      transition opacity 1s 1.6s $ease 

      p

        position: absolute;
        left: 50%;
        top: 8px;
        width: 100px;
        transform: translateX(-50%);
        color $blue
        font-family: $f-title
        font-size: 14px;
        text-align center
        font-weight 500


</style>